<template>
	<div id="eqhelper" class="gcardfr" v-loading="loading">
		<el-row :gutter="20" class>
			<el-col :span="12">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="addTer">{{ $t('app_add') }}</el-button>
				<el-button size="small" type @click="moveEQ">{{ $t('app_imp') }}</el-button>
				<el-button size="small" type @click="expEq">{{ $t('app_derive') }}</el-button>
			</el-col>
			<el-col :span="6" ssshow="$isAdminType()">
				<div class="glineflex">
					<label class="glinelb">{{ $t('terminal.device_sn') }}：</label>
					<el-input size="small" v-model="srcEquip" @keyup.enter.native="indexget" placeholder></el-input>
				</div>
			</el-col>
			<el-col oooffset="$isAdminType()?0:6" :span="6">
				<div class="glineflex">
					<label class="glinelb">{{ $t('merchant.client_name') }}：</label>
					<el-input size="small" v-model="scust" @keyup.enter.native="indexget" placeholder></el-input>
				</div>
			</el-col>
		</el-row>
		<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" @row-click="rowClick" :data="tableData"
			@selection-change="batchSelected" style="width: 100%">
			<!-- <el-table-column type="selection" width="55"></el-table-column> -->
			<el-table-column prop="deviceId" :label="$t('terminal.device_sn')" width></el-table-column>
			<el-table-column prop="mappingDeviceId" :label="$t('merchant.mapping_sn')" width></el-table-column>
			<!-- <el-table-column v-if="$isAdminType()" prop="agentName" label="渠道商"></el-table-column> -->
			<el-table-column prop="customer" :label="$t('merchant.client_name')" width></el-table-column>
			<el-table-column prop="platform" :formatter="setPlt" :label="$t('merchant.app_Platform')" width></el-table-column>
			<el-table-column prop="createTime" :label="$t('merchant.mapping_time')" width="190"></el-table-column>

			<el-table-column :label="$t('app_operation')" width="100">
				<template slot-scope="scope">

					<el-button @click="delRow(scope.row.deviceId,scope.row.mappingDeviceId)" type="text"
						class="opdcolor">{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>

		<EquipHelper :config="config"></EquipHelper>
		<ExportEqHelper :config="eeconfig"></ExportEqHelper>

		<el-dialog @open='preSet' @close="closeDia" class="gstdia" :title="$t('merchant.add_mapping')" :visible.sync="isadd">
			<el-form :model="tform" :rules="rules" ref="ruleForm">
				<el-form-item :label="$t('terminal.device_sn')" :label-width="$formlbWidth" prop="deviceId">
					<el-input v-model="tform.deviceId" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.app_customer')" :label-width="$formlbWidth" prop="customer">
					<el-input v-model="tform.customer" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('merchant.app_Platform')" :label-width="$formlbWidth" prop="platform">
					<el-select v-model="tform.platform" :placeholder="$t('app_select')">
						<el-option v-for="item in $plats" :key="item.vl" :label="item.lb" :value="item.vl">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button type="primary" @click="beforeRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div>-->
		</el-dialog>
	</div>
</template>

<style>
	.eqbs-ball-green {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(82, 196, 26, 1);
	}

	.eqbs-ball-gray {
		width: 6px;
		height: 6px;
		display: inline-block;
		border-radius: 6px;
		overflow: hidden;
		background: rgba(191, 191, 191, 1);
	}
</style>

<script>
	import Pages from "@/components/Pages.vue";
	import Merchant from "@/components/Merchant.vue";
	import ExportEqHelper from "@/components/ExportEqHelper.vue";
	import EquipHelper from "@/components/EquipHelper.vue";
	export default {
		data() {
			return {
				eeconfig: {},
				isadd: false,
				importData: [],
				showIpRs: false,
				sortMc: {},
				editMc: {},
				srcEquip: "",
				scust: "",
				agentId: "",
				pconfig: "",
				tableData: [],
				showBcDia: true,
				tform: {
					deviceId: "",
					customer: "",
					platform: "",
				},
				bcform: {},
				page: 1,
				total: 0,
				loading: false,
				sRows: [],
				config: "",
				showEquDia: false,
				merchantId: "",
				rules: {
					platform: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					deviceId: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					customer: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}]
				}
			};
		},
		components: {
			Pages,
			Merchant,
			EquipHelper,
			ExportEqHelper
		},
		methods: {
			expEq() {
				var _this = this;
				this.eeconfig = {
					callback: () => {
						_this.getList();
					}
				};
			},
			setPlt(row) {
				var rs = this.$plat[row.platform]
				return rs ? rs : row.platform
			},
			preSet() {
				//// set df mc, is agentid
				var usr = this.$getTmp('user')
				this.tform.merchant = usr.agentId
				this.setMcCtr(usr.agentId)
			},
			moveEQ() {
				var _this = this;
				this.config = {
					agid: "",
					showDia: true,
					callback: () => {
						_this.getList();
					}
				};
			},
			indexget() {
				this.page = 1;
				this.getList();
			},
			rowClick(row, column) {
				if (column.label != this.$t('app_operation')) {
					// this.toDetail(row);
				}
			},
			bindRqs(did) {
				if (did.length != 0) {
					this.$bindMerch(
						this.merchantId,
						did,
						res => {
							if (res.status == 200) {
								this.getList();
								this.showEquDia = false;
								this.$message.success(res.message);
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				} else {
					this.showEquDia = false;
				}
			},
			batchDel() {
				this.$showMsgBox(
					this.$t('app_delete_question_2'),
					() => {
						var arr = [];
						this.sRows.forEach(item => {
							arr.push(item.merchantId);
						});
						this.delRqs(arr.toString());
					},
					""
				);
			},
			delRqs(did, mpdid) {
				this.loading = true;
				this.$helperDel(did, mpdid, res => {
						this.loading = false;
						if (res.status == 200) {
							this.getList();
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						this.loading = false;
					}
				);
			},
			delRow(did, mpdid) {
				this.$showMsgBox(
					this.$t('app_delete_question'),
					() => {
						this.delRqs(did, mpdid);
					},
					""
				);
			},
			addTer() {
				this.isadd = true;
				// this.setMcCtr("");
			},
			toDetail(row) {
				// this.$router.push({
				//   path: "/merchant/detail",
				//   query: {
				//     deviceid: "",
				//     merchantId: row.merchantId,
				//     mcno: row.merchantNo
				//   }
				// });
			},
			getList() {
				this.loading = true;
				var deviceId = this.srcEquip
				var customer = this.scust
				this.$helperList(this.page, this.$gRow, deviceId, customer, res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			batchSelected(val) {
				this.sRows = val;
			},
			closeDia() {
				this.isadd = false
				this.tform = {
					deviceId: "",
					customer: "",
					platform: "",
				}
			},
			closeBcDia() {
				this.showBcDia = false;
				// this.tform.shopName = ''
			},
			beforeRqs() {
				this.$refs["ruleForm"].validate(valid => {
					if (valid) {
						this.okDia();
					}
				});
			},
			okDia() {
				this.loading = true;
				var fm = this.tform
				this.$helperAdd(fm.deviceId, fm.customer, fm.platform, res => {
						this.loading = false;
						if (res.status == 200) {
							this.closeDia()
							this.$message.success(res.message)
							this.getList()
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			setMcCtr(vl) {
				var _this = this;
				this.editMc = {
					type: "1",
					size: "",
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.merchant = vl
					}
				};
			}
		},
		mounted() {

			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};

			this.getList();

			this.sortMc = {
				size: "small",
				value: "",
				type: "0",
				callback: vl => {
					//alert(vl)
					this.agentId = vl;
					this.indexget();
				}
			};
		}
	};
</script>
